import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { Role } from '@models';
import { RoleService, NotificationService } from '@services';
import { catchError, of } from 'rxjs';

export const roleResolver: ResolveFn<Role | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const service = inject(RoleService);
  const notificationService = inject(NotificationService);
  const router = inject(Router);

  const id = route.paramMap.get('id');
  if (!id) {
    return of(null);
  }

  return service.read(id).pipe(
    catchError((err) => {
      console.error(err);

      switch (err?.status) {
        case 401:
          break;
        default:
          router.navigate(['/404'], {
            skipLocationChange: true,
          }).finally(() => {
            notificationService.error('Failed to load the user role.');
          });
          break;
      }

      return of(null);
    }),
  );
};
